import {AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit, Renderer} from '@angular/core';
import {Router} from '@angular/router';
import {DashboardDataService} from "../../services/dashboard-data.service";

// import {setTimeout} from 'timers';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
})
export class MainComponent implements OnInit, OnDestroy, AfterViewChecked {
  menuClick: boolean;
  loading: boolean;

  menuButtonClick: boolean;

  topbarMenuButtonClick: boolean;

  topbarMenuClick: boolean;

  topbarMenuActive: boolean;

  activeTopbarItem: Element;

  layoutStatic: boolean;

  sidebarActive: boolean;

  mobileMenuActive: boolean;

  darkMenu: boolean;

  isRTL: boolean;

  loadingSubscriber;

  constructor(
    public renderer: Renderer,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private dashboardDataService: DashboardDataService) {
  }

  ngAfterViewChecked(){
    this.loadingSubscriber = this.dashboardDataService.getLoadingState().subscribe(state => {
      this.loading = state;
    });
    this.cdr.detectChanges();
  }

  // TODO better to do redirect on data load
  ngOnInit() {
    // setTimeout(() => {
    //   this.router.navigateByUrl('main/(sub:key-user-metrics)');
    // }, 500);
  }

  ngOnDestroy(): void {
    this.loadingSubscriber.unsubscribe();
  }


  onWrapperClick() {
    if (!this.menuClick && !this.menuButtonClick) {
      this.mobileMenuActive = false;
    }

    if (!this.topbarMenuClick && !this.topbarMenuButtonClick) {
      this.topbarMenuActive = false;
      this.activeTopbarItem = null;
    }

    this.menuClick = false;
    this.menuButtonClick = false;
    this.topbarMenuClick = false;
    this.topbarMenuButtonClick = false;
  }

  onMenuButtonClick(event: Event) {
    this.menuButtonClick = true;

    if (this.isMobile()) {
      this.mobileMenuActive = !this.mobileMenuActive;
    }

    event.preventDefault();
  }

  onTopbarMobileMenuButtonClick(event: Event) {
    this.topbarMenuButtonClick = true;
    this.topbarMenuActive = !this.topbarMenuActive;
    event.preventDefault();
  }

  onTopbarRootItemClick(event: Event, item: Element) {
    if (this.activeTopbarItem === item) {
      this.activeTopbarItem = null;
    } else {
      this.activeTopbarItem = item;
    }

    event.preventDefault();
  }

  onTopbarMenuClick(event: Event) {
    this.topbarMenuClick = true;
  }

  onSidebarClick(event: Event) {
    this.menuClick = true;
  }

  onToggleMenuClick(event: Event) {
    this.layoutStatic = !this.layoutStatic;
  }

  isMobile() {
    return window.innerWidth <= 1024;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/main/main.component.ts